import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const NotFound = lazy(
  () => import('./NotFound.eager').then(mod => ({default: mod.NotFound})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
